var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorefrontOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dealer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 19.994,
    height: 18,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#333",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1890",
    "data-name": "Groupe 1890",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1889",
    "data-name": "Groupe 1889",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_611",
    "data-name": "Trac\\xE9 611",
    d: "M19.9,5.89l-1.05-4.37A1.964,1.964,0,0,0,16.935,0H3.045a1.964,1.964,0,0,0-1.9,1.52L.095,5.89a3.375,3.375,0,0,0,.62,2.88A3.834,3.834,0,0,0,1,9.06V16a2.006,2.006,0,0,0,2,2H17a2.006,2.006,0,0,0,2-2V9.06a3.7,3.7,0,0,0,.28-.28,3.364,3.364,0,0,0,.62-2.89m-2.99-3.9,1.05,4.37a1.356,1.356,0,0,1-.25,1.17,1.173,1.173,0,0,1-.94.47,1.25,1.25,0,0,1-1.21-1.14L14.975,2ZM10.995,2h1.96l.54,4.52a1.344,1.344,0,0,1-.33,1.07,1.193,1.193,0,0,1-.95.41,1.272,1.272,0,0,1-1.22-1.31ZM6.485,6.52,7.035,2h1.96V6.69A1.285,1.285,0,0,1,7.7,8a1.2,1.2,0,0,1-.89-.41,1.421,1.421,0,0,1-.33-1.07m-4.45-.16L3.045,2h1.97l-.58,4.86A1.257,1.257,0,0,1,3.225,8a1.151,1.151,0,0,1-.93-.47,1.322,1.322,0,0,1-.26-1.17M2.995,16V9.97a1.81,1.81,0,0,0,.23.03,3.129,3.129,0,0,0,2.24-.95,3.216,3.216,0,0,0,2.31.95,3.17,3.17,0,0,0,2.23-.93A3.278,3.278,0,0,0,12.3,10a3.175,3.175,0,0,0,2.24-.95,3.129,3.129,0,0,0,2.24.95A1.81,1.81,0,0,0,17,9.97V16Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorefrontOutlinedWhite);
export default __webpack_public_path__ + "static/media/StorefrontOutlinedWhite.438fc3eda313f0d5a7ec976af88a168d.svg";
export { ForwardRef as ReactComponent };